import React, { useState } from "react";
import "./ForgetPassword.css";
import { resetPassword } from "../../api/index";
import Swal from "sweetalert2";
import { useMutation } from "react-query";
import { Link } from "react-router-dom";

function ResetPassword({ match }) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const { mutate } = useMutation(resetPassword, {
    onSuccess: (data) => {
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Success! Password reset successfully.",
        showConfirmButton: false,
        timer: 2000,
      }).then(() => {
        window.location = "/";
      });
    },
    onError: (error) => {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Oops! Password reset failed.",
        text: error?.response?.data?.message,
        showConfirmButton: false,
        timer: 2000,
      });
    },
  });

  const clickHandler = async (e) => {
    e.preventDefault();

    try {
      mutate({ token: match.params.token, password, confirmPassword });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className="forget_page">
      <div className="doctor_forget_div">
        <div className="forget_img">
          <Link to={"/"}>
            <img src="/img/ladydoctor.jpg"></img>
          </Link>
        </div>
      </div>
      <div className="forget_back">
        <div className="forget_div">
          <div className="forget_logo">
            <Link to={"/"}>
              <img src="/img/logo1.png"></img>
            </Link>
          </div>
          <div className="reset_heading">Reset Password</div>
          <div class="forget_p">Please set the new password below</div>
          <div className="forget_input">
            <img alt={"logo"} src="/img/smart-key.svg" />
            <input
              className="email_in"
              name="password"
              placeholder="Password"
              type="password"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="forget_input">
            <img alt={"logo"} src="/img/smart-key.svg" />
            <input
              className="email_in"
              name="confirmPassword"
              type="password"
              placeholder="Confirm Password"
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>
          <div className="sign_menu">
            <button
              className="themebutton_end"
              style={{ width: "210px", height: "40px" }}
              onClick={clickHandler}
            >
              Reset Password
            </button>
            <div className="img_wrap_end">
              <img src="/img/chevron-right.svg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
